import { months } from "@kalaporssi/shared";

export const MSHORT = ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"];
export const monthName = (m: number) => months[m] ?? "";

export const fkg = (n: number) => `${Math.round(n).toLocaleString("fi-FI")} kg`;
export const feur = (n: number, d = 0) =>
  `${n.toLocaleString("fi-FI", { minimumFractionDigits: d, maximumFractionDigits: d })} €`;
export const fp = (n: number | null | undefined) =>
  n == null ? "–" : n.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const pct = (d: number) => `${d >= 0 ? "+" : ""}${Math.round(d * 100)} %`;

export function sensitivity(elasticity: number) {
  return elasticity < 0.5
    ? "vakaa"
    : elasticity < 0.9
      ? "kohtalainen"
      : elasticity < 1.15
        ? "herkkä"
        : "erittäin herkkä";
}
